<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
          >
            Lista de fotos o videos
          </div>
          <div class="flex flex-col w-full">
              <div>
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="flex flex-wrap w-full item-center justify-center px-3 mb-6 md:mb-0">

                    <template v-if="list_path_media_folder">
                      <template v-for="path_media_folder in list_path_media_folder">
                        <div class="w-1/2 item-center justify-center">
                          <div class="relative w-full p-4">
                            <img
                              v-if="path_media_folder.mimeType == 'image/jpeg' || path_media_folder.mimeType == 'image/png'"
                              :src="replaceURL(path_media_folder.fileName)"
                              class="h-full w-full object-cover mt-1"
                              alt
                            />
                            
                            <video
                              v-if="path_media_folder.mimeType == 'video/mp4'"
                              :src="replaceURL(path_media_folder.fileName)"
                              class="h-full w-full object-cover mt-1"
                              controls
                              controlslist="nodownload"
                            />
                            <!-- <div
                              class="rounded-full h-12 w-12 absolute bottom-0 right-0 items-center justify-center bg-gray-200 hover:bg-gray-400 hover:text-gray-800 cursor-pointer rounded-full border-solid border-4 border-white"
                              @click="editMultimedia(path_media_folder)"
                            >
                              <svg
                                class="m-2 text-gray-500"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                heigth="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M12 20h9" />
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                              </svg>
                            </div> -->
                            <div
                              class="rounded-full h-12 w-12 absolute top-0 right-0 items-center justify-center bg-gray-200 hover:bg-gray-400 hover:text-gray-800 cursor-pointer rounded-full border-solid border-4 border-white"
                              @click="openModalDeleteMultimedia(path_media_folder)"
                            >
                              <svg 
                                class="m-2 text-gray-500"
                                xmlns="http://www.w3.org/2000/svg" 
                                height="24" 
                                width="24"
                                viewBox="0 0 45 45"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="M14 25.35H34V22.35H14ZM24 44Q19.75 44 16.1 42.475Q12.45 40.95 9.75 38.25Q7.05 35.55 5.525 31.9Q4 28.25 4 24Q4 19.8 5.525 16.15Q7.05 12.5 9.75 9.8Q12.45 7.1 16.1 5.55Q19.75 4 24 4Q28.2 4 31.85 5.55Q35.5 7.1 38.2 9.8Q40.9 12.5 42.45 16.15Q44 19.8 44 24Q44 28.25 42.45 31.9Q40.9 35.55 38.2 38.25Q35.5 40.95 31.85 42.475Q28.2 44 24 44ZM24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24Q24 24 24 24ZM24 41Q31.25 41 36.125 36.125Q41 31.25 41 24Q41 16.75 36.125 11.875Q31.25 7 24 7Q16.75 7 11.875 11.875Q7 16.75 7 24Q7 31.25 11.875 36.125Q16.75 41 24 41Z"/>
                              </svg>
                            </div>
                          </div>
                        </div>  
                      </template>
                    </template>
                  </div>
                  
                  <div class="w-full px-3">
                    <img
                      v-if="imageSelected"
                      :src="levantamientoImageUrl"
                      class="h-full w-full object-cover"
                      alt
                    />

                    <video
                      v-if="videoSelected"
                      :src="levantamientoVideoUrl"
                      class="h-full w-full"
                      controls
                    ></video>
                  </div>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <template v-if="list_path_media_folder && selectType">
                  <button
                    v-if="(selectType == 'video/mp4' && list_path_media_folder.length < 1) || ((selectType == 'image/jpeg' || selectType == 'image/png') && list_path_media_folder.length < 4)"
                    class="ml-2 bg-green-500 hover:bg-secondary-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="newMediaModal()"
                  >
                    Agregar Imagen y/o video
                  </button>
                </template>

                <template v-else>
                  <button
                    class="ml-2 bg-green-500 hover:bg-secondary-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="newMediaModal()"
                  >
                    Agregar Imagen y/o video
                  </button>
                </template>
                <button
                  class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
                <!-- <button
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento()"
                >
                  Guardar
                </button> -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar este multimedia?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteMultimedia()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <user-raising-new-media-modal
      :showing="showNewMediaModal"
      @close="closeNewMediaModal()"
      @updateImage="updateImage($event)"
    ></user-raising-new-media-modal>
  </div>
</template>
<script>
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import UserRaisingNewMediaModal from "./UserRaisingNewMediaModal";

export default {
  name: 'user-raising-list-media-modal',
  data() {
    return {
      selectType: null,
      list_path_media_folder: null,
      fileMimeType: null,
      raising: null,
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      errors: {
        file_extension: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      showingConfirm: false,
      showingSuccessDelete: false,
      selectMultimedia: null,
      showNewMediaModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    }
  },
  mounted() {
    EventBus.$on("newMediaModal", this.setData);
  },
  components: {
    AlertDialog,
    UserRaisingNewMediaModal
  },
  methods: {
    reset: function () {
      this.selectType = null;
      this.list_path_media_folder = null;
      this.fileMimeType = null;
      this.raising = null;
      this.imageSelected = false;
      this.videoSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        file_extension: false,
        codeError: "Ha ocurrido un error",
      };
      this.showingSuccess = false;
      this.showingError = false;
      this.selectMultimedia = null;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(raising) {
      this.raising = Object.assign({}, raising);
      this.fetchMultimedia();
    },
    fetchMultimedia() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/levantamientos/media/list",
          {
            id: this.raising.id
          },
          this.config
        )
        .then((response) => {
          this.list_path_media_folder = JSON.parse(response.data.list.path_media_folder);
          if(this.list_path_media_folder && this.list_path_media_folder.length > 0){
            this.selectType = this.list_path_media_folder[0].mimeType;
          }else{
            this.selectType = null;
          }
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    openModalDeleteMultimedia(path_media_folder){
      this.showingConfirm = true;
      this.selectMultimedia = path_media_folder;
    },
    deleteMultimedia() {
      this.$root.$emit("showLoading");
      this.config['data'] = {
        fileName: this.selectMultimedia.fileName,
        mimeType: this.selectMultimedia.mimeType
      }

      this.axios
        .delete(`../apidev/levantamientos/media/delete/${this.raising.id}`, this.config)
        .then(() => {
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
          this.fetchMultimedia();
        })
        .catch(error => {
          this.showingConfirm = false;
          this.showingError = true;
          this.catchError(error);
        });
    },
    newMediaModal() {
      this.showNewMediaModal = true;
      EventBus.$emit("newMediaModal", {
        id: this.raising.id,
        selectType: this.selectType
      });
    },
    closeNewMediaModal() {
      this.showNewMediaModal = false;
    },
    updateImage() {
      this.fetchMultimedia();
    },
    replaceURL(path){
      return path.replace("./", '../apidev/');
    },
    catchError(error) {
      console.log("ERROR", error)
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },

  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
